import React, { useState, useEffect } from 'react';
import { Spinner } from '../../../../common';
import MenuSortOrder from './MenuSortOrder.jsx';
import { RadioButtonsPicker } from '../../../../common/form/FormElements';
import { useTranslation } from 'react-i18next';
import {
  useGetMenuTreeQuery,
  useSaveMenuItemsOrderMutation,
} from '../../../../../redux/services/menu';
import { useToastMessages } from '../../../../../hooks/useToastMessages';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { useNavigate } from 'react-router-dom';

const MenuOrderPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isEnglish, setIsEnglish] = useState(false);

  const { saveSuccess: showSaveSuccess } = useToastMessages();

  const { data: menu, isLoading } = useGetMenuTreeQuery(isEnglish);

  useEffect(() => {
    document.title = t('Úprava poradia položiek menu') + ' - FRI CMS';
  }, []); // Runs on mount

  const [saveMenuItemsOrder, { isSuccess: isSaveSuccess }] =
    useSaveMenuItemsOrderMutation();

  useEffect(() => {
    if (isSaveSuccess) {
      showSaveSuccess();
      navigate(routes.cmsMenu);
    }
  }, [isSaveSuccess]);

  return isLoading ? (
    <Spinner />
  ) : (
    <MenuSortOrder
      isEnglish={isEnglish}
      menu={menu}
      requestInProgress={isLoading}
      onOrderSave={(menuData) => saveMenuItemsOrder({ menuData, isEnglish })}
      languagePicker={
        <RadioButtonsPicker
          items={[
            { id: 'slovak', name: 'slovak', label: t('Slovenská verzia') },
            { id: 'english', name: 'english', label: t('Anglická verzia') },
          ]}
          title={t('Verzia menu pre jazyk')}
          defaultId={isEnglish ? 'english' : 'slovak'}
          onChange={(chosenId) => setIsEnglish(chosenId === 'english')}
        />
      }
    />
  );
};

export default MenuOrderPage;
